import Avatar from "@mui/material/Avatar";

export default function AccountPopover() {
  return (
    <>
      <Avatar
        src={"A"}
        alt={"Admin"}
        sx={{
          width: 40,
          height: 40,
          bgcolor: "#0CAF60",
          fontWeight: "bold",
          // border: `solid 2px #00A76F`,
        }}
      />
    </>
  );
}
